import { render, staticRenderFns } from "./WallEmojiPicker.vue?vue&type=template&id=008190cb&scoped=true"
import script from "./WallEmojiPicker.vue?vue&type=script&lang=js"
export * from "./WallEmojiPicker.vue?vue&type=script&lang=js"
import style0 from "./WallEmojiPicker.vue?vue&type=style&index=0&id=008190cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008190cb",
  null
  
)

export default component.exports